import {
  CatchBoundary,
  createFileRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';
import ErrorScreen from '../components/ErrorScreen';
import MainFooter from '../components/MainFooter';
import MainHeader from '../components/MainHeader';
import ScrollWrapper from '../components/ScrollWrapper';
import { DEFAULT_TITLE } from '../utility/head';

export const Route = createFileRoute('/_marketing')({
  component: LayoutComponent,
  head: () => ({
    meta: [
      {
        title: DEFAULT_TITLE,
      },
      {
        property: 'og:locale',
        content: 'en_GB',
      },
    ],
  }),
  ssr: true,
  loader: (arg) => {
    const pathname = arg.location.pathname.replace(/\/+$/, '');

    return {
      pathname,
    };
  },
});

function LayoutComponent() {
  const routerState = useRouterState();
  const { pathname } = Route.useLoaderData();

  return (
    <ScrollWrapper>
      <CatchBoundary
        getResetKey={() => routerState.resolvedLocation?.state.key ?? ''}
        errorComponent={ErrorScreen}
      >
        <MainHeader pathname={pathname} />
        <main className="pt-16 min-h-[calc(100vh-5rem)] lg:min-h-[calc(100vh-6rem)] relative overflow-hidden flex flex-col grow">
          <Outlet />
        </main>
        <MainFooter />
      </CatchBoundary>
    </ScrollWrapper>
  );
}
